import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { HpButton } from '@hp/ui';
import { invalidatePipelineState } from '../pipeline/queries';
import { trpc } from '../../api/trpc';
import { invalidateMerge, type MergeJob } from './queries';
import { ErrorAlert } from '../../components/error-alert';

export function JobControls({ job }: { job: MergeJob }) {
  const { t } = useTranslation(['jobs', 'common']);
  const action = useMutation(
    trpc.merge.control.mutationOptions({
      onSuccess: () => Promise.all([invalidateMerge(), invalidatePipelineState()]),
    }),
  );
  const act = (verb: 'pause' | 'resume' | 'cancel'): void => action.mutate({ id: job.id, action: verb });
  const busy = (verb: 'pause' | 'resume' | 'cancel'): boolean => action.isPending && action.variables?.action === verb;
  const cancellable = job.status === 'queued' || job.status === 'running' || job.status === 'paused';
  if (!cancellable) return null;
  return (
    <div className="bo-sections">
      <div className="bo-row">
        {job.status === 'running' && (
          <HpButton icon="pause" busy={busy('pause')} disabled={action.isPending} onClick={() => act('pause')}>
            {t('common:actions.pause')}
          </HpButton>
        )}
        {job.status === 'paused' && (
          <HpButton
            variant="secondary"
            icon="play"
            busy={busy('resume')}
            disabled={action.isPending}
            onClick={() => act('resume')}
          >
            {t('common:actions.resume')}
          </HpButton>
        )}
        <HpButton
          className="bo-danger"
          icon="stop"
          busy={busy('cancel')}
          disabled={action.isPending}
          onClick={() => act('cancel')}
        >
          {t('common:actions.cancel')}
        </HpButton>
      </div>
      <ErrorAlert error={action.error} />
    </div>
  );
}
